"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.behaviorDependencies = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var reporter_1 = require("./reporter");
exports.behaviorDependencies = new inversify_1.ContainerModule(function (bind) {
    bind(event_tracking_core_1.TYPES.IBehaviorAdapterService)
        .to(reporter_1.Reporter)
        .inRequestScope();
});
